import { useContext, useState, useEffect } from "react";
import { ConstantContext } from "components/context/ConstantProvider";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";

export const UserField = (props) => {
  const { users } = useContext(ConstantContext);
  const [options, setOptions] = useState(undefined);

  useEffect(() => {
    if (users)
      setOptions(
        users
          .sort((a, b) => {
            if (a.is_active && !b.is_active) {
              return -1;
            } else if (!a.is_active && b.is_active) {
              return 1;
            }
            return a.fullname.localeCompare(b.fullname);
          })
          .map((user) => [
            user.id,
            `${user.fullname}${user.is_active ? "" : " (not active)"}`,
          ]),
      );
  }, [users]);

  if (!options) return <></>;

  return <ListSelectField options={options} {...props} />;
};

export default UserField;
